import debounce from 'lodash.debounce';

export const debouncedSearch = debounce((val: any, func: Function) => {
  func(val);
}, 350);